// MAIN LIMB MOTION PROCESSING
//
import { initTables,
         arrayToknAscSort,
         arrayLengthDesSort,
         NOW,
		 getDegree } from "../util/util";
import { HISTORY,
		 CONSTS,
		 STATS,
		 INFO,
         TIMES,
		 CONES,
		 TURNS} from '../util/object'
import { timerDisplayResult } from '../util/annotate'
//import * as THREE from 'three';
import { Vector3 } from 'three';



var kconsole_log = (true) ? console.log : () => {};		// true will enable console.log
var kconsole_log2 = (false) ? console.log : () => {};	// debug marker-dict detection mechanism
var kconsole_log3 = (false) ? console.log : () => {};	// low level motion details
var kconsole_log4 = (false) ? console.log : () => {};	// rep marker LOOP detection traffic
var kconsole_log5 = (true) ? console.log : () => {};	// STATIC gesture detection from tokens



// DECODE MARKER: reverse token back to a marker
//   - FORMAT:  <limb> <member> <max_deg1> <max_deg2> <del_deg1> <del_deg2> <time_del>
//
/*      LIMBS:    [ "TL": A, 
                    "TR": B, 
                    "BL": C, 
                    "BR": D, 
                    "CH": E, 
                    "CB": F ];
//      MEMBERS:  [ larm: A, 
                    lfam: B, 
                    rarm: C, 
                    rfam: D, 
                    lthg: E, 
                    lleg: F, 
                    rthg: G, 
                    rleg: H, 
                    ched: I, 
                    cbod: J ]
//      DEG-1:    [ 0deg:  0,
                    20deg: 1,
                    40deg: 2,
                    80deg: 3,
                    100deg: 4,
                    120deg: 5 ]
//      DEG-2:    0 = -90deg, 6 = +90deg  (-90 to 90)
//      TIME:     log10
//
//     - TODO: need to look up k-nn to distill down further
*/
export function getMotionMarker(alpha) {

    function alphaMarker(alpha) {
        const NUMB={"A":0, "B":1, "C":2, "D":3, "E":4, "F":5, "G":6, "H":7, "I":8, "J":9, "K":10, "L":11};
        return NUMB[alpha];
    }

    function degree1Marker(alpha) {
        var numb = parseInt(alpha);
        var out = (numb * 20) + 10;
        return out;
    }

    function degree2Marker(alpha) {
        var numb = parseInt(alpha);
        var out = (numb * 30) - 90 + 15;
        return out;
    }

    function timeMarker(alpha) {
        var numb = parseInt(alpha);
        return (Math.pow(10, numb));
    }

    var out = {};
    out.tokn = alpha;
    out.limb = alphaMarker(alpha[0]);
    out.memb = alphaMarker(alpha[1]);
    out.amx1 = degree1Marker(alpha[2]);
    out.amx2 = degree1Marker(alpha[3]);
    out.adl1 = degree2Marker(alpha[4]);
    out.adl2 = degree2Marker(alpha[5]);
    out.tdel = timeMarker(alpha[6]);

    kconsole_log("motion.2197:    ~ ~ ~ ~ ~ ~  CONVERT TO MOTION MARKER   token=",alpha, 
                " out: { limb=", out.limb, " memb=", out.memb, " amx1=", out.amx1, 
                " amx2=", out.amx2, " adl1=", out.adl1, " adl2=", out.adl2, " tdel=", out.tdel, " }");
    return out;
}


// condense the motion vector to a simple token
//     - TODO: need to look up k-nn to distill down further
//     - deg1: 1 = 20deg, 6 = 120deg  (0 to 120)
//     - deg2: 0 = -90deg, 6 = +90deg  (-90 to 90)
//     - time: log10
//
export function getMotionToken(marker) {

    function alphaToken(numb) {
        const ALPHA=["A","B","C","D","E","F","G","H","I","J","K","L"];
        numb = (numb < 0) ? 0 : numb;
        numb = (numb > 10) ? 10 : numb;
        return ALPHA[numb];
    }

    // 0 to 120
    function degree1Token(deg0) {
        var deg = null, out = null;
        deg = deg0;
        if (deg0 < 0) deg = 0;
        if (deg0 > 120) deg = 120;
        out = deg / 20;
        return parseInt(out);
    }

    // -90 to +90
    function degree2Token(deg0) {
        var deg = null, out = null;
        deg = deg0 + 90;        // shift up
        if (deg0 < -90) deg = 0;
        if (deg0 > 90) deg = 180;
        out = deg / 30;
        return parseInt(out);
    }

    // rough time relationship
    //
    function timeToken(time) {
        return (parseInt(Math.log10(time)));
    }

    var token = alphaToken(marker.limb) + alphaToken(marker.memb) + degree1Token(marker.amx1)+ degree1Token(marker.amx2)+ degree2Token(marker.adl1)+ degree2Token(marker.adl2) + timeToken(marker.tdel);
    //console.log("marker.2198:    ~ ~ ~ ~ ~ ~  ",token,"  marker=", marker);
    return token;
}


// UTIL
//     - calc (x-angle, z-angle) between base & limb
//     - base is @ (0, 0, z)
//     - return (x-angle, y-angel, distance)
//     - input format: { name: "left_elbow",​ score: 0.44, ​ x: 0.127, ​ y: -0.285, ​ z: -0.188 }
function calcLimb(base0, limb0) {

    var name = limb0.name;
    var dx = limb0.x - base0.x;
    var dy = limb0.y - base0.y;
    var dz = limb0.z - base0.z;
    var len = Math.sqrt(dx*dx + dy*dy + dz*dz);

    var ndx = dx / len;
    var ndy = dy / len;
    var ndz = dz / len;

    var base = unitVector(base0);
    var limb = unitVector(limb0);
    var degree = getVectorAngle(base, limb);

    var [xdegree, ydegree, zdegree] = angle3D(ndx, ndy, ndz);
    var obj = {}
    obj.xd = xdegree;
    obj.yd = ydegree;
    obj.zd = zdegree;
    obj.len = len;
    obj.degree = parseInt(degree);        // vector similarity

    return obj;

    //console.log("limb.137:     .  .  .  .  ",name,"  xd=", xdegree," yd=", ydegree," zd=", zdegree, " dx=", dx.toFixed(3), " dy=",dy.toFixed(3), " dz=",dz.toFixed(3));
}



// UTIL
//
function validLimb(limb) {
    var show = false;
    switch (limb) {
        case 0:
            if (INFO.TL_state === true) show = true;
            break;
        case 1:
            if (INFO.TR_state === true) show = true;
            break;
        case 2:
            if (INFO.BL_state === true) show = true;
            break;
        case 3:
            if (INFO.BR_state === true) show = true;
            break;
        case 4:
            if (INFO.CH_state === true) show = true;
            break;
        case 5:
            if (INFO.CB_state === true) show = true;
            break;
    }
    return show;
}


// UTIL
//   - extract from dict and set the INFO state
//
export function setValidLimbs(tokens) {
    for (var t in tokens){
        var token = tokens[t];
        var marker = getMotionMarker(token);
        var limb = CONSTS.LIMBS_NAME[marker.limb];
        var field = limb+"_state";
        INFO[field] = true;
        //console.log("limb.194: "+t+":  "+field+" = true");
    }
}

// MAIN: Use 3D data to extract body signals
//    - extract 3D unit vector of all limb members (used for marker extraction)
//    - extract limb member distance (for camera angle calibration)
//
export function process3DSignals(keypoints3D) {
    var signals = {}, out = "";
    if(keypoints3D === undefined) { return null};

    function mid(field, start, end) {
        var mid = start[field] + ((start[field] - end[field])/2);
        return mid;
    }

	var reye3 = keypoints3D[INFO.idx["left_eye"]];		// left eye
	var leye3 = keypoints3D[INFO.idx["right_eye"]];		// right eye
	var rear3 = keypoints3D[INFO.idx["left_ear"]];		// left ear
	var lear3 = keypoints3D[INFO.idx["right_ear"]];		// right ear
	var nose3 = keypoints3D[INFO.idx["nose"]];	
	var rmou3 = keypoints3D[INFO.idx["mouth_left"]];
	var lmou3 = keypoints3D[INFO.idx["mouth_right"]];

	var lsho3 = keypoints3D[INFO.idx["left_shoulder"]];
	var rsho3 = keypoints3D[INFO.idx["right_shoulder"]];
	var lelb3 = keypoints3D[INFO.idx["left_elbow"]];
	var relb3 = keypoints3D[INFO.idx["right_elbow"]];
	var lwri3 = keypoints3D[INFO.idx["left_wrist"]];
	var rwri3 = keypoints3D[INFO.idx["right_wrist"]];

	var lhip3 = keypoints3D[INFO.idx["left_hip"]];
	var rhip3 = keypoints3D[INFO.idx["right_hip"]];
	var lkne3 = keypoints3D[INFO.idx["left_knee"]];
	var rkne3 = keypoints3D[INFO.idx["right_knee"]];
	var lank3 = keypoints3D[INFO.idx["left_ankle"]];
	var rank3 = keypoints3D[INFO.idx["right_ankle"]];

	var sho_prob = Math.floor((lsho3.score + rsho3.score)/2*100);
	var hip_prob = Math.floor((lhip3.score + rhip3.score)/2*100);
	var knee_prob = Math.floor((lkne3.score + rkne3.score)/2*100);
	var ank_prob = Math.floor((lank3.score + rank3.score)/2*100);
	var elb_prob = Math.floor((lelb3.score + relb3.score)/2*100);
	var wri_prob = Math.floor((lwri3.score + rwri3.score)/2*100);
    // each limb segment has (x-angle, z-angle)
    var mout2 = {"x": mid("x", lmou3, rmou3), "y": mid("y", lmou3, rmou3), "z": mid("z", lmou3, rmou3), "score": ((lmou3.score+rmou3.score)/2)}
    var eyes2 = {"x": mid("x", leye3, reye3), "y": mid("y", leye3, reye3), "z": mid("z", leye3, reye3), "score": ((leye3.score+reye3.score)/2)}
    var shos2 = {"x": mid("x", lsho3, rsho3), "y": mid("y", lsho3, rsho3), "z": mid("z", lsho3, rsho3), "score": ((lsho3.score+rsho3.score)/2)}
    var hips2 = {"x": mid("x", lhip3, rhip3), "y": mid("y", lhip3, rhip3), "z": mid("z", lhip3, rhip3), "score": ((lhip3.score+rhip3.score)/2)}
    //console.log("3D.162:   keypoints3D  reye3.score=",reye3.score, " lhip3.score=", lhip3.score);
    //console.log("anal.188:       # # # # # # # # # # # # # # # # # # 3D SCORE:  sho=", sho_prob, "  elb=", elb_prob,"  wri=", wri_prob, "  hip=", hip_prob,"  knee=", knee_prob,"  ankle=", ank_prob);

    // get unit vector for each limb
    //    - *.vector3
    //    - *.len
    //    - *.score
    //
    //var body = new THREE.Vector3(0, -1, 0);
    //var body = unitVector(eyes2, hips2);        // center stick
    var larm = unitVector(lsho3, lelb3);    // upper limbs
    var lfam = unitVector(lelb3, lwri3);
    var rarm = unitVector(rsho3, relb3);
    var rfam = unitVector(relb3, rwri3);
    var lthg = unitVector(lhip3, lkne3);    // lower limbs
    var lleg = unitVector(lkne3, lank3);
    var rthg = unitVector(rhip3, rkne3);
    var rleg = unitVector(rkne3, rank3);

    //var ched = unitVector(mout2, eyes2);      // use center-mouth and center eye (?) -  NO
    var ched = unitVector(shos2, eyes2);      // use center-shoulder to center eye (?)
    var cbod = unitVector(hips2, shos2);      // use center-shoulders and center-hips (?)
    var lbod = unitVector(shos2, hips2);      // for lower body, points down

    // get relative angle against the "anchor" limb
    //
    signals.larm = getVectorInfo(lbod, larm);
    signals.lfam = getVectorInfo(larm, lfam);
    signals.rarm = getVectorInfo(lbod, rarm);
    signals.rfam = getVectorInfo(rarm, rfam);

    signals.lthg = getVectorInfo(lbod, lthg);
    signals.lleg = getVectorInfo(lthg, lleg);
    signals.rthg = getVectorInfo(lbod, rthg);
    signals.rleg = getVectorInfo(rthg, rleg);

    signals.ched = getVectorInfo(cbod, ched);      // use center-eyes and nose (?)
    signals.cbod = getVectorInfo(lbod, cbod);      // need to use 2D absolute coord?


    // normal 3D vector from the nose: not used
    var x = ((-rear3.x - -lear3.x) / 2) + -lear3.x;
    var y = (-rear3.y + -lear3.y) / 2;
    var z = -nose3.z - (-rear3.z + -lear3.z) / 2;
    var VEC = "VEC=("+(-Math.round(x*100))+","+(-Math.round(y*100))+","+(-Math.round(z*100))+")";

    var lear_x = -Math.round(lear3.x*100);
    var lear_y = -Math.round(lear3.y*100);
    var lear_z = -Math.round(lear3.z*100);
    var rear_x = -Math.round(rear3.x*100);
    var rear_y = -Math.round(rear3.y*100);
    var rear_z = -Math.round(rear3.z*100);

    var nose_x = -Math.round(nose3.x*100);
    var nose_y = -Math.round(nose3.y*100);
    var nose_z = -Math.round(nose3.z*100);
    var mout_y = -Math.round(mout2.y*100);
    var mout_z = -Math.round(mout2.z*100);
    var shos_y = -Math.round(shos2.y*100);

    var rwri_x = -Math.round(rwri3.x*100);
    var rwri_y = -Math.round(rwri3.y*100);
    var rwri_z = -Math.round(rwri3.z*100);
    var lwri_x = -Math.round(lwri3.x*100);
    var lwri_y = -Math.round(lwri3.y*100);
    var lwri_z = -Math.round(lwri3.z*100);


    // DETECT: LOOK **DOWN** USING HUERISTICS ONLY
    //    - THESE ARE ONLY VALIDE FOR STANDING STRAIGHT UP

    //    - if node_y closer to ear_y  or  nose_y closer to shos_y then looking down
    //
    var low_ear_y = (lear_y < rear_y) ? lear_y : rear_y;    // take the lower one as base, in case of tilt
    if ((low_ear_y > (nose_y + 7)) || (nose_y < (shos_y + 10))) {
        signals.look_down = true;
    }

    // DETECT: LOOK **LEFT** (screen right)
    //if ((nose_x < -2) && (rear_x < 3)) {
    //if ((nose_x < -4) && (rear_x < 3)) {
    if ((nose_x < -8) && (rear_x < -8)) {
        signals.look_left = true;
    }

    // DETECT: LOOK **RIGHT** (screen left)
    //if ((nose_x > 6)) {
    if ((nose_x > 8) && (lear_x > 10)) {
        signals.look_right = true;
    }



    // DETECT: ** RIGHT WRIST ** UP (screen left)
    if ((rwri_x > 40)) {
        out = out + " XXX   W.x="+rwri_x+"    N.x="+nose_x+ " E.z="+lear_z+" N.z="+nose_z;
        signals.right_hand = true;
    }

    // DETECT: ** LEFT WRIST ** UP (screen left)
    if ((lwri_x > 40)) {
        signals.left_hand = true;
    }

    var hd = signals.ched;
    var hidx = HISTORY.length - 1;
    //console.log("215:    . . .3D-HEAD  hidx=",hidx, "  nose.x=",nose_x," nose.y=",nose_y, " mout.y=",mout_y, "shos_y=",shos_y," low_ear.y=",low_ear_y, " rear_x=",rear_x, " lear_x=",lear_x," nose.z=",nose_z, " mout.z=",mout_z," hd.zd=",hd.zd, " (",hd.dz.toFixed(2), ")    xd=",hd.xd, " (",hd.dx.toFixed(2), ")    yd=",hd.yd, " (",hd.dy.toFixed(2),") ", 
    //            (signals.look_down ? "  DOWN" : ""), (signals.look_left ? "  LEFT" : ""), (signals.look_right ? "  RIGHT" : ""));

    if(out !== ""){
        //console.log("3D.230:   3D-NOSE   ",out, "       ",DEG," ",VEC, "  ",LEAR, "  ",REAR, "  ",NOSE);
    }

    return signals;
}


// returns unit THREE.vector3
//
function unitVector(vec0, vec1) {
    var x = (vec0.x - vec1.x);
    var y = (vec0.y - vec1.y);
    var z = (vec0.z - vec1.z);
    var len = Math.sqrt(x*x + y*y + z*z);
    //var uvec3 = new THREE.Vector3(x/len, y/len, z/len);
    var uvec3 = new Vector3(x/len, y/len, z/len);
    uvec3.score = (vec0.score + vec1.score)/2;
    uvec3.len = len;
    return uvec3;
}



function getVectorInfo(vec0, vec1) {

    var degree = getVectorAngle(vec0, vec1);
    var dx = vec1.x - vec0.x;
    var dy = vec1.y - vec0.y;
    var dz = vec1.z - vec0.z;

    var [ xdgr, ydgr, zdgr] = angle3D(dx, dy, dz);  // relative angle to each other, vec0 is 0 deg

    var out = {}
    out.degree = parseInt(degree);
    out.dx = dx;
    out.dy = dy;
    out.dz = dz;

    out.xd = xdgr;
    out.yd = ydgr;
    out.zd = zdgr;
    out.score = Math.floor((vec0.score + vec1.score)/2*100);
    out.len = vec1.len;     // for camera angle calc

    return out;
}

// ref: 
function angle3D(x, y, z) {
    //var vRight = new THREE.Vector3(1, 0, 0);
    //var vUp = new THREE.Vector3(0, 1, 0);
    //var vFront = new THREE.Vector3(0, 0, 1);
    //var vThis = new THREE.Vector3(-x, -y, -z);
    var vRight = new Vector3(1, 0, 0);
    var vUp = new Vector3(0, 1, 0);
    var vFront = new Vector3(0, 0, 1);
    var vThis = new Vector3(-x, -y, -z);

    var xDegree = getVectorAngle(vThis, vRight);
    var yDegree = getVectorAngle(vThis, vUp);
    var zDegree = getVectorAngle(vThis, vFront);

    //console.log("3D.226:   3D-NOSE            x=",-x.toFixed(3),"   y=",-y.toFixed(3),"   z=",-z.toFixed(3), "  xDegree=",Math.floor(xDegree)," yDegree=",Math.floor(yDegree)," zDegree=",Math.floor(zDegree));
    return [ parseInt(xDegree), parseInt(yDegree), parseInt(zDegree) ];

}

// INPUT vectors NEED TO BE UNIT VECTORS (length = 1)
//
function getVectorAngle(vectorA, vectorB) {

    // Store some information about them for below
    var dot = vectorA.dot(vectorB);
    var lengthA = vectorA.length();
    var lengthB = vectorB.length();

    // Now to find the angle
    var theta = Math.acos( dot / (lengthA * lengthB) ); // Theta = 3.06 radians or 175.87 degrees
    var degree = theta * (180 / Math.PI);       // convert radians to degree

    return degree;
}



// UTIL:
//
function calcAngle(seg0, seg1) {
    if(!seg0 || !seg1) return null;

    var d0 = seg0.degree;
    var d1 = seg1.degree;
    var delta = d0 - d1;
    return delta;
}



// go through all limbs and calculate reversal
//     - sigs1 is signal from last frame
//     - 3D angle based on unit vector, degree = (0, 180)
//
//
export function calc3DMotionAngles(hidx, sigs0, sigs1, t1) {
    var t0 = {};
    var omsg = hidx+":  ";
    var smsg = hidx+":  ";
    var tmsg = hidx+":  ";
    var mmsg = hidx+":  ";
    const LIMBS = ["TL", "TR", "BL", "BR", "C"];

    //console.log("turn3d.1890:      . . .  START CALC 3D MOTION   hidx=",hidx);      //, " sigs0=",sigs0, "  sigs1=",sigs1);
    var out = {};
    var ended = [];
    var ix = null;
    var prime = null;
    var mix = [0, 0, 0, 0, 0];
    var couple = null;
    for (var field in sigs0) {
        if (field.length > 4) continue;    // only process limbs

        out[field] = calcAngle(sigs0[field], sigs1[field]);

        omsg = omsg+"   "+field+": "+ out[field];
        var a = "a"+field;  // cum sum of angle delta
        var t = "t"+field;  // start time
        var m = "m"+field;  // NOTE: *** THIS IS FRAME COUNT, NEED "total elapse time"
        var s = "s"+field;  // same angle cnt, pose held at this position
        //console.log("turn3d.1902:     . . . . . . . . .   field=",field, " sigs0=",sigs0[field].degree, " sigs1=",sigs1[field].degree);
        ended[field] = false;
        if (t1[a] === undefined) {  // init first frame
            t0[a] = 0;
            t0[t] = hidx;       // NOTE: NEED TO HAVE CURRENT VIDEO TIME HERE!
            t0[m] = 0;
            t0[s] = 0;
        } else {
            var sp = Math.sign(t1[a]);      // sign of prev cumulated angle
            var sc = Math.sign(out[field]);     // sign of current angle chg
            //console.log("turn3d.1904:     . . . . . . . . .   ", field, " prev.cum.sign=",sp, " this.sign=",sc, "  this.delta=", out[field], 
            //        " cum.delta=", t1[a], " this=",sigs0[field].degree, " prev=",sigs1[field].degree);


            t0[s] = t1[s];      // NOTE: must do this here to avoid undefines
            ended[field] = false;
            //if (((sp === 0) || (sc === 0) || (sc === sp)) && (t1[s] < CONSTS.LIMB_MAX_SAME_POSE)) 
            if ((sp === 0) || (sc === 0) || (sc === sp)) {

                    // IMPORTANT FILTERING HUERISTICS: filter out bad changes
                    //    - cumulated angle too small (< 10) => not significant
                    //    - time too short (from start) => unintentional jitter
                    //    - delta angle too big in one frame (> 30) => glitch
                    //    - delta angle too small in one frame (< 3) => glitch
                    //
                    var dt = hidx - t1[t];
                    //if ((Math.abs(out[field]) > 2) && (Math.abs(out[field]) < 30) && (Math.abs(t1[a]) > 10) && (dt > 3)) 
                    //console.log("turn3d.384:                        CHECK   . . .  hidx=",hidx, " field=",field, " out[field]= (2< ",Math.abs(out[field])," <30)  sigs0=",sigs0[field].degree, 
                    //            " sig1=",sigs1[field].degree, "  t1[a]=",Math.abs(t1[a]), "(>",MAX_SAME_CNT,")  dt=",dt," (> 3)  t0[s]=",t0[s], " s=",s);

                    //if ((Math.abs(out[field]) > 2) && (Math.abs(out[field]) < 30) && (Math.abs(t1[a]) > MAX_SAME_CNT) && (dt > 3)) 
                    if ((dt > 3) && (Math.abs(t1[a]) > 10)) {
                        if (Math.abs(out[field]) < 2) {
                            if (INFO.gesture_allowed === true) {
                                if (Math.abs(t1[s]) > CONSTS.LIMB_MAX_SAME_POSE) {
                                    //console.log("turn3d.391:    # # # DETECT REPEAT GESTURE END   . . . . .  hidx=",hidx, " field=",field, " t1[a]=",t1[a], " t0[s]=",t0[s], " t1[s]=",t1[s]," dt=",dt," s=",s);
                                    ended[field] = true;        // for play signal UI
                                } else {
                                    t0[s] = (t1[s] === undefined) ? 0 : t1[s] + 1;       // track how long it stayed at same angle
                                    //if (true && (t1[s] > 3))         // DEBUG ONLY TO REDUCE CLUTTER
                                        //console.log("turn3d.376:             . . . . .  hidx=",hidx, " field=",field, " out[field]=",out[field], 
                                        //            " t1[a]=",t1[a], " t0[s]=",t0[s], " t1[s]=",t1[s], " t1[t]=",t1[t], " s=",s, " sc=",sc, " sp=",sp);
                                }
                            }
                        } else 

                        if ((Math.abs(out[field]) > 2) && (Math.abs(out[field]) < 30) && (INFO.gesture_allowed === false)) {
                            //console.log("turn3d.391:    # # # DETECT ONE TIME END       . . . . .  hidx=",hidx, " field=",field, " t1[a]=",t1[a], " t0[s]=",t0[s], " t1[s]=",t1[s]," dt=",dt," s=",s);
                            ended[field] = true;        // for play signal UI
                            //t0[s] = 0;      // NO!!!! angle chgd, reset
                        }
                    } 
            } 
            
            /*else { t0[s] = 0;      // did this later } */


            t0[a] = t1[a] + out[field];
            t0[t] = t1[t];      // keep track of start of the turn;
            if (ended[field] === true) {
                t0[m] = hidx - t1[t];       // finished time delta in hidx
            }
        }
    }
    //console.log("  - - - - - ",hidx, "  t0=",t0);

    // second pass to figure out the couple
    //
    var markers = [];
    var header0 = "           ******";
    for (var field in sigs0) {
        if (field.length > 4) continue;    // only process limbs (4 chars)
        var a = "a"+field;  // cum sum of angle delta
        var t = "t"+field;  // start time
        var m = "m"+field;  // NOTE: *** THIS IS FRAME COUNT, NEED "total elapse time"
        var s = "s"+field;  // same angle cnt 

            const LIMBS = ["TL", "TR", "BL", "BR", "CH", "CB"];
            const MEMBERS = {larm: 0, lfam: 1, rarm: 2, rfam: 3, lthg: 4, lleg: 5, rthg: 6, rleg: 7, ched: 8, cbod: 9}
            const SPACES = "                                        ";
            //var limb = null;
            switch (field) {
                case "larm":
                    couple = "lfam"
                    ix = 0;
                    prime = 1;
                    break;
                case "lfam":
                    couple = "larm"
                    ix = 0;
                    prime = 0;
                    break;
                case "rarm":
                    couple = "rfam"
                    ix = 1;
                    prime = 1;
                    break;
                case "rfam":
                    couple = "rarm"
                    ix = 1;
                    prime = 0;
                    break;
                case "lthg":
                    couple = "lleg"
                    ix = 2;
                    prime = 1;
                    break;
                case "lleg":
                    couple = "lthg"
                    ix = 2;
                    prime = 0;
                    break;
                case "rthg":
                    couple = "rleg"
                    ix = 3;
                    prime = 1;
                    break;
                case "rleg":
                    couple = "rthg"
                    ix = 3;
                    prime = 0;
                    break;
                case "ched":
                    couple = ""
                    ix = 4;
                    prime = 1;
                    break;
            }
            var limb = SPACES.substring(0, (ix * 4))+LIMBS[ix];
            //console.log("2013:   limbo="+limbo+"   limb="+limb+"]");

            if (mix[ix] === 0) {
                mix[ix] = t1[t];     // set to last time we chked
            }

            if (ended[field] === true) {
                var dir = (t1[a] > 0) ? "++++++++++" : "-----------";
                var dh = ((hidx-mix[ix]).toString()+"   ").substr(0,4);
                kconsole_log3("turn3d.456:  @",hidx,"-",dh, "    ",limb," ",dir," ",field, " a.delta=",t1[a], " a.max=", sigs0[field].degree, "     time=",t0[m], " ix=",ix, " same=",t0[s]);

                //ended = false;      // start another loop
                mix[ix] = hidx;     // checking now
                var a01 = "a"+couple;  // cum sum of angle delta
                var da = calcAngle(sigs0[couple], sigs1[couple]);

                // create signal vector
                //     - use time delta of < 3 hidx
                //     - later, consolidate with the couple segment if they are close enough in time
                // signal: <angle1:end>, <angle1:delta>, <angle2:end>, <angle2:delta>, <time:delta>
                var end0 = sigs0[field].degree;       // end angle
                var delta0 = t0[a];     // chg in angle

                var end1 = (sigs0[couple]) ? sigs0[couple].degree : -1;       // end angle
                //var delta1 = (t0[a01]) ? (t0[a01] + da) : -1;
                var delta1 = (t1[a01]) ? (t1[a01] + da) : -1;   // last delta + new delta
                var time0 = t0[m];     // chg in time from min to max angle
                //var time0 = t0[t] - t1[t];     // chg in time from min to max angle

                var marker = {};
                if (prime == 1) {
                    //marker = [LIMBS[ix], hidx, end0, delta0, end1, delta1, time0]
                    marker.limb = ix;       // store index only
                    marker.memb = MEMBERS[field];       // store index only
                    marker.amx1 = end0;
                    marker.adl1 = delta0;
                    marker.amx2 = end1;
                    marker.adl2 = delta1;
                    marker.tdel = time0;
                    //console.log(" ------ EVEN ------- ix=",ix, "  rem=",(ix % 2))
                    
                } else {
                    //marker = [LIMBS[ix], hidx, end1, delta1, end0, delta0, time0]
                    marker.limb = ix;
                    marker.memb = MEMBERS[field];
                    marker.amx1 = end1;
                    marker.adl1 = delta1;
                    marker.amx2 = end0;
                    marker.adl2 = delta0;
                    marker.tdel = time0;
                    //console.log(" ------ ODD ------- ix=",ix, "  rem=",(ix % 2))
                }
                marker.time = hidx;     // need for cluster calc later
                marker.tokn = getMotionToken(marker);               // convert to token format, then match against dict
                var [ token, dist ] = knnBestMatch(marker);        // returns null if no match
                marker.tokn0 = (token) ? token.tokn : null;   // null means no match
                marker.dist = parseInt(dist);     // distance from the target (closeness of match)
                marker.scor = sigs0[field].score;       // confidence level
                marker.same = t0[s];          // how many frames stayed at this position
                //getMotionMarker(marker.tokn);     // debug: reverse test

                //XXCD
                if (INFO.gesture_allowed === true) {
                    var matched = (token) ? token.tokn : null;

                    // Note: To analyze, match against video hidx
                    //
                    kconsole_log5("turn3d.546.xxx:                    . . . PRE-TOKEN0  hidx=",hidx, " matched=",matched, " token=",marker.tokn, " dist=", parseInt(dist), "   marker=",marker);

                    //  Note: Check getMotionMarker() for decoder ring
                    var show_pre_token = false;       // USE THIS TO DEBUG GESTURE DETECT ACCURACY
                    if (show_pre_token) {
                        var tt0 = Date.now();
                        TIMES.timer_stop_display = tt0 + 500;
                        INFO.notify_title = marker.tokn+"  "+matched;
                        INFO.notify_color = "red";
                    }
                }

                if (token) {
                    kconsole_log5("turn3d.577.xxx:               + + + FOUND TOKEN=",token.tokn, "  hidx=", hidx,":  ",field, " dist=",parseInt(dist)," s=",sigs0[field].score, " same=",t0[s], "  :::  t0[a]=", t0[a], " t1[a]=",t1[a], " t0[s]=",t0[s], " delta=",out[field], " dgr=",sigs0[field].degree);
                } else {
                    marker.tokn0 = null;
                }
                markers.push(marker);       // Note: is there a need for a null token marker?

                end0 = marker.amx1;
                end1 = marker.amx2;
                delta0 = marker.adl1;
                delta1 = marker.adl2;

                var leader = ((hidx - INFO.last_hidx) > 6) ? "========" : "        ";
                kconsole_log3("turn3d.2076: "+hidx+" "+leader+" <",LIMBS[ix], ", ",field, ", ",hidx,", ",end0,", ",delta0,", ",end1, ", ",delta1, ", ", time0,">", "  lhidx=",INFO.last_hidx);
                INFO.last_hidx = hidx;   // need to survive across calls

                t0[a] = 0;      // get ready for the next one
                t0[t] = hidx;
                t0[m] = hidx - t1[t];
                t0[s] = 0;
                //console.log("turn3d.2035:                       . . . .",hidx,":  t0=",t0);
            }


            kconsole_log3("turn3d.1901:   . . . ",header0, hidx,":  ",field, " s=",sigs0[field].score, "  :::  t0[a]=", t0[a], " t1[a]=",t1[a], " t0[s]=",t0[s], " delta=",out[field], " dgr=",sigs0[field].degree);
            header0 = "                 ";

        if ((Math.abs(out[field]) > 1) && (Math.abs(t1[a]) > 5)) {
        }

        smsg = smsg+"   "+a+": "+ t0[a];
        tmsg = tmsg+"   "+t+": "+ t0[t];
        mmsg = mmsg+"   "+m+": "+ ((t0[m]) ? t0[m] : "  ");
    }

    t0["hidx"] = hidx;
    return [t0, markers];
}




// detectMotionReverse(f0.signals.larm, f0.signals.lfam);     // lower segment

// 
function detectMotionReverse(useg, lseq) {

}


const MAX_LOOKAHEAD = 20;
const MAX_SCORE = 20;
const MIN_CUM_SCORE = 20;       // lowest normalized threshold to get in the motion vector
const MASTER_VALUE = 100;      // points for matching master at this location

// auto annotation of possible repeat motion sequence patterns
//    - score the sequence based on pattern matched
//    - each marker has an array of value sums
//    - loop to each marker with same value, calc sum at that position
//    - use INFO.detection_mark[] to group related tokens together
//
export function knnAnalyzeLoopPattern (markers0) {
    var sum0 = 0, sum1 = 0, sum2 = 0;
    if(!markers0 || (markers0.length === 0)) return;

    // filter out not usable markers
    //var markers = markers0.filter(m => { return m.tokn0 !== null });
    var m0 = Object.assign({}, markers0[0]);        // copy object
    var markers = [m0];
    var last = m0;
    for (var m = 1; m < markers0.length; m++) {
        var marker0 = markers0[m];
        //console.log("2155:     . .  ",m, ":   tokn0=",marker0.tokn0, "  tokn=",marker0.tokn);
        if (marker0.tokn0 !== null) {

            //console.log("2157:        . . . last=", last, " marker0=",marker0);
            if (marker0.tokn0 !== last.tokn0) {
                markers = markers.concat(marker0);
                kconsole_log("2162:                             + + + +  ADD MARKER:  ",marker0.tokn0,"  @",m,  "  last=",last.tokn0);     //, " this=",marker0, " last=",last);
            } else {
                kconsole_log("2166:                                      CONSEQ DUP:  ",marker0.tokn0,"  @",m);     //, " this=",marker0, " last=",last);
            }
            last = marker0;
        } else {
            kconsole_log("2184:                                                - - - NULL TOKN0:  ",marker0.tokn,"  @",m,  "  last=",last.tokn0);     //, " this=",marker0, " last=",last);
        }
    }
    kconsole_log("2146:  Marker Filtering...  m0=",markers0.length, " m1=",markers.length, "   ",markers);

    for (var m = 0; m < markers.length; m++) {
        var marker = markers[m];
        kconsole_log("2172:     . .  ",m, ":   tokn0=",marker.tokn0, "  tokn=",marker.tokn);   // dump
    }

    var scores = []
    var max_score = 0;

    //for (var m0  = 0; m0 < 15; m0++) 
    for (var m0  = 0; m0 < markers.length - 1; m0++) {
        var master0 = markers[m0];
        if (m0 >= markers.length) continue;

        kconsole_log("2157:   # # # # # # # # # #   m0:",master0.tokn0, "@",m0, "   last_sum0=",sum0);
        sum0 = 0;
        for (var i = 1; i < MAX_LOOKAHEAD; i++) {
            var c0 = m0 + i;
            if (c0 >= markers.length) continue;

            var curr0 = markers[c0];
            if (curr0.tokn0 === master0.tokn0) {
                kconsole_log("2192:        = = = = =   m0:",master0.tokn0, "@",m0,"  c0:",curr0.tokn0, "@",c0, " last_sum1=",sum1);
                sum1 = MASTER_VALUE;     // master match is worth something

                // scores based on the following marker stream
                //
                var delj = c0 - m0;
                var maxj = (delj > MAX_LOOKAHEAD) ? MAX_LOOKAHEAD : delj;
                for (var j = 1; j < maxj; j++) {
                    var m1 = m0 + j;
                    if (m1 >= markers.length) continue;
                    var master1 = markers[m1];

                    sum2 = 0;
                    var delk = m1 - m0;     // ?
                    var maxk = (delk > MAX_LOOKAHEAD) ? MAX_LOOKAHEAD : delk;
                    for (var k = 1; k < maxk; k++) {
                        var c1 = c0 + k;
                        if (c1 >= markers.length) continue;

                        var curr1 = markers[c1];
                        if (curr1.tokn0 === master1.tokn0) {
                            var delta = (MAX_SCORE - k);
                            sum2 = sum2 + delta;        // closer match is higher score
                            kconsole_log("2202:              - -  m1:",master1.tokn0, "@",m1, "   c1: ", curr1.tokn0, "@",c1, " delta=",delta,"  sum2=",sum2, " sum1=",sum1, " sum0=",sum0);
                            break;
                        } else {
                            //console.log("2284:                     MISS   m1: ", master1.tokn0, "@",m1, " c1:",curr1.tokn0, "@",c1, "    sum2=",sum2);
                        }
                    }
                    sum1 = sum1 + sum2;
                }

                break;  // done with this
            }
            sum0 = sum0 + sum1;
        }

        // store the sum for this position
        //
        scores[m0] = sum0;
        if (sum0 > max_score) max_score = sum0;
    }

    kconsole_log("loop.2195:  scores=",scores);
    //scores.forEach(s => {s = s / max_score * 100});     // nomralize

    var last_time = 0;
    var last_hidx_marker = 0;
    var midx = 0;
    for (var s = 0; s < scores.length; s++) {
        var score = parseInt(scores[s] / max_score * 100);
        var token = markers[s].tokn0;
        var time = markers[s].time;
        var hidx = markers[s].time;
        var limb = parseInt(markers[s].limb);
        var delta = time - last_time;

        var hidx_marker0 = INFO.detection_mark[midx];
        var hidx_marker1 = INFO.detection_mark[midx + 1];
        //kconsole_log("2299:                 ~ ~  midx=",midx, ":  hidx", hidx, "  hidx_marker0=",hidx_marker0, " last_hidx=",last_hidx_marker);
        if (hidx_marker0 && (hidx_marker0 > hidx) && (hidx_marker0 !== last_hidx_marker)) {
            last_hidx_marker = hidx_marker0;        // show only once
            midx = midx + 1;
            //kconsole_log("2300:     ~ ~ ~ ~ ~ ~ ~ TIME MARKER ",midx, ":  ", hidx_marker0, "~ ~ ~ ~ ~ ~");
        }

        //console.log("2243:          ",s, ":   limb=",limb, " TL=",INFO.TL_state, " TR=",INFO.TR_state, " BL=",INFO.BL_state, " BR=",INFO.BR_state);
        var show = validLimb(limb);
        if (show === true) {
            if(score > MIN_CUM_SCORE) {
                kconsole_log("2236:     + + +  ",s, ":   ",token, "  score=",score, "       delta=",delta);   // dump
                last_time = time;
            } else {
                kconsole_log("2287:            ",s, ":         ",token, "  (",score,") delta=", delta);   // dump
            }
        }
    }
    kconsole_log("loop.2291: DISPLAY TOKENS dict=",INFO.knn_token_dictionary);
}




const MIN_CLUSTER_DISTANCE = 80;        // size of the cloud

// caculate distance matrix to auto determine marker clusters
//    = use this to extract high frequency tokens to use in the sequence
//
export function knnCluster(markers0) {
    if (!markers0 || (markers0.length === 0)) return;

    var markers = [];
    for (var n = 0; n < markers0.length; n++){
        // filter and make a copy
        //
        var m0 = markers0[n];
        var limb = m0.limb;
        var token = m0.tokn0;
        var valid = validLimb(limb);
        if (valid === true) {
            kconsole_log("kcluster.2310:         ",n,":   VALID ",token, " @", limb, " m0=",m0);
            markers = markers.concat(m0);
        }
    }

    markers.sort(arrayToknAscSort)
    var clusters = []; // clusters, filled dynamically
    var rindex = new Array(markers.length);   // reverse index
    for (var m  = 0; m < markers.length; m++) {
        var src = markers[m];
        var token = src.tokn;
        rindex[m+1] = null;

        kconsole_log("kcluster.2150: ",m,":    . . . PROCESS: ",token);
        for (var i = parseInt(m) + 1; i < markers.length; i++) {
            var dst = markers[i];
            if (!rindex[i]) {
                if (src.memb === dst.memb) {
                    var dist = knnDistance(src, dst);
                    if (dist < MIN_CLUSTER_DISTANCE) {

                        if(!clusters[token]) clusters[token] = [];
                        clusters[token].push(i);
                        rindex[i] = token;

                        kconsole_log("kcluster.2152:       ",i,"  ADD  ",token," ",clusters[token],"   . . . m=",m, " i=",i, "  m[m]=",markers[m].tokn, " m[i]=",markers[i].tokn,  " dist=",parseInt(dist), " tot_mkr=",markers.length);
                    } else {
                        kconsole_log("kcluster.2150:           ",i,"    FAR  . . . m=",m, " i=",i, "  m[m]=",markers[m].tokn, " m[i]=",markers[i].tokn,  " dist=",parseInt(dist), " tot_mkr=",markers.length);

                    }
                } else {
                    //console.log("kcluster.2167:       ",i,"          - - -  DIFF.1  . . . m=",m, " i=",i, "  m[m]=",markers[m].tokn, " m[i]=",markers[i].tokn,  " dist=",parseInt(dist), " tot_mkr=",markers.length);

                }
            } else {
                //console.log("kcluster.2177:             ",i,"    - - -  USED.2  . . . m=",m, "rindx=",rindex[i], " dst=",dst.tokn);
            }
        }
    }

    // store the top cluster into dictionary
    //    - cut off at 1/3 of the top frequency item
    //
    if(!clusters) return;

    var csizes = new Array(clusters.length);
    var i = 0;
    for(var x in clusters) {
        var c = clusters[x];
        //console.log("2192:       . . . e=",e, " i=", i);
        csizes[i] = {length: c.length, token: x};
        i += 1;
    }

    csizes.sort(arrayLengthDesSort);
    kconsole_log("kcluster.2190:        # # # # # #  CSIZE=",csizes);

    INFO.knn_token_dictionary = [];     // reload

    if (csizes.length > 0) {
        var top = csizes[0].length;
        var cutoff = top / 3;
        for (var x in csizes) {
            var csize = csizes[x];
            //console.log("kcluster.2168:            = = = = = =  ",x, ": ", cluster);
            if (csize.length > cutoff) {
                INFO.knn_token_dictionary.push(csize.token);
            }
        }
    }

    //markers.sort(arrayTimeAscSort)
    kconsole_log("kcluster.2204:        # # # # # #  TOKEN DICTIONARY =", INFO.knn_token_dictionary);

} 




const SCORE_THRESH = 60;
const MAX_DIST = 80;    //80;    // 60;      // if token not chosen properly, dist may be big
const MIN_DIST = 45;    //45;    // 20;        // to calc score, at dist = 20, score is 100
const MAX_SCORE_BUCKETS = 30;       // number of segments for even the most complicated loops



// Real Time Processing of 3D Limb Motion Vectors to detect loops
//     - for limb loops, there are four limbs:  arm + forearm, thigh + leg (both left and right)
//     - each limb we track (upper[start_angle, end_angle, angle_delta], lower[start_angle, end_angle, angle_delta], time_delta)
//     - collect this dataset for each drill to act as a custom dictionary
//     - use K-nearest neighbor for classification, to break a drill down into these Limb Motion Vectors (LMV)
//     - keep an active target bucket - does not match to previous bucket
//     - if new marker time delta is big enough, move to next bucket
//     - most loops can be broken into 4 segments, 2 to the right, 2 back to the left
//
export function analyzeMotionMarkers(pmarkers0) {
	var hidx = HISTORY.length - 1;
    if (pmarkers0.length === 0) return;

    var targets = INFO.knn_drill_tokens;
    //var targets = INFO.knn_token_dictionary;
    var active_bucket = 0, match_bucket = 0, start_bucket, end_bucket, bscores = [];
    var tmdelta = 0, tmlast = 0, tdelta = 0, big_cnt = 0;
    var last_bucket = targets.length - 1;

    INFO.knn_player_markers = INFO.knn_player_markers.concat(pmarkers0);
    var pmarkers = INFO.knn_player_markers;
    if (!INFO.knn_token_dictionary || !INFO.knn_drill_tokens[0] || 
        (INFO.knn_token_dictionary.length === 0) || (INFO.knn_drill_tokens[0].length === 0)) return;
    //knnCluster(pmarkers);       // debug clustering


    // score the marker sequence against target buckets
    //
    var mstart = (INFO.knn_last_rep_marker) ? INFO.knn_last_rep_marker : 0;
    //kconsole_log4("mscore.2153:  ",INFO.rep_run_cnt," # # # # # # # START ANALYZE MOTION MARKERS  pmarkers=", pmarkers.length, "  mstart=",mstart, " # # # # # # # # #");
    console.log("mscore.2153:     hidx=",hidx,"    rep=",INFO.rep_run_cnt," # # # # # # # START ANALYZE MOTION MARKERS  pmarkers=", pmarkers.length, "  mstart=",mstart, " # # # # # # # # #");
    for (var m = mstart; m < pmarkers.length; m++) {
        var pmarker = pmarkers[m];
        var token = pmarker.tokn0;
        var dist = pmarker.dist;
        hidx = pmarker.time;

        if (!token) continue;

        tmdelta = (tmlast === 0) ? 0 : (pmarker.time - tmlast);       // if first one, stay in bucket
        if (active_bucket == (targets.length - 1)) {
            start_bucket = active_bucket;
            end_bucket = 0;     // wrap around
        } else {
            start_bucket = active_bucket;
            end_bucket = active_bucket + 1;     // wrap around
        }
        //console.log("mscore.2455:            bucket=[",start_bucket,":",end_bucket,"]   START bscores[",start_bucket,"]=",bscores[start_bucket]);     //, " pmarker=",pmarker);

        //console.log("mscore.2181:               start_bucket=",start_bucket, " end_bucket=",end_bucket);
        var bounds = [start_bucket, end_bucket];
        for (var i in bounds) {
            var b = bounds[parseInt(i)];        // for...in always result in string
            var bucket = targets[b];
            if (!bscores[b]) bscores[b] = 0;

            for (var t in bucket) {
                var target = bucket[t];

                kconsole_log4("mscore.2454:           ",m,"-",hidx,":  CHECK  target=", target, " token=", token,  " bucket=[",start_bucket,":",end_bucket,"_",b,"_]   bscore[",b,"]=",bscores[b]);     //, " pmarker=",pmarker);
                if (token === target) {
                    // got a match, dist=0 is 100 pts, dist=60 is 0 pts
                    var dist1 = (dist < MIN_DIST) ? MIN_DIST : dist;
                    var score = parseInt((MAX_DIST - dist1) / (MAX_DIST - MIN_DIST) * 100);
                    bscores[b] = parseInt(bscores[b]) + score + 25;
                    kconsole_log4("mscore.2161:          _ _ _ ", m,"-",hidx,":",token," GOT MATCH   bucket=[",start_bucket,":",end_bucket,"_",b,"_]    dist=", parseInt(dist), " score=", score, " bscores["+b+"]=",bscores[b], " tmdelta=",tmdelta, " last=",INFO.knn_last_marker);
                    match_bucket = b;
                    break;
                }
                //ttlast = target.time;
            }
        }

        //if (match_bucket === end_bucket)
        var sbkt_cnt = 1 + ((targets[start_bucket].length - 1)/ 3);    // account for multiple matches in bkt, heuristics based
        var start_score = parseInt(bscores[start_bucket] / sbkt_cnt);  // % of total in bucket, need to positive ID
        var ebkt_cnt = 1 + ((targets[end_bucket].length - 1)/ 3);    // account for multiple matches in bkt, heuristics based
        var end_score = parseInt(bscores[end_bucket] / ebkt_cnt);  // % of total in bucket, need to positive ID
        //console.log("mscore.2473:       ^ ^ ^  s_src[",start_bucket,"]=",bscores[start_bucket], " s_score",start_score, " scnt=",sbkt_cnt.toFixed(2), " e_src[",end_bucket,"]=",bscores[end_bucket], "  e_score=",end_score, " ecnt=",ebkt_cnt.toFixed(2));
        // if next bucket score is above threshold, move active up so we don't match backwards
        //
        if ((start_score > SCORE_THRESH) && (end_score > SCORE_THRESH)) {
                if (end_bucket == 0) {
                    big_cnt = big_cnt + 1;
                    kconsole_log4("mscore.2190:     ",big_cnt,"++++++++++++ DETECT NEW START OF LOOP  marker=", m,"-",hidx, ": last_bucket=",active_bucket, " S-score=",start_score, " E-score=",end_score, "  +++++++++++");
                    kconsole_log4("mscore.2485:                   ",INFO.knn_drill_tokens);
                    active_bucket = 0;
                    if (m > INFO.knn_last_marker) {
                        INFO.rep_run_cnt = INFO.rep_run_cnt + 1;     // Note: Is this right?
                    }
                    INFO.knn_last_rep_marker = m;       // restart at the start of the partial loop

                    // for (var i = 0; i < MAX_SCORE_BUCKETS; i++)  bscores[i] = 0;     // clear it up for next loop
                } else {
                    kconsole_log4("mscore.2183:         = = = = >",m,"-",hidx,": ",token," ADVANCE BUCKET TO ", end_bucket," s-score=",start_score," e-score=",end_score, "  < = = = =  ");
                    active_bucket = end_bucket;
                }

                //console.log("mscore.2432:         clear START_bkt[",start_bucket,"]");
                bscores[start_bucket] = 0;     // cleaning up as we go, for when it loops back
        } else {
            kconsole_log4("mscore.2186:                  ",m,"-",hidx,":  LOW S-score=",start_score, " E-score=",end_score," ",token, " bucket=[",start_bucket,":",end_bucket,"_",b,"_]   bs[end_bkt]=",bscores[end_bucket], " target[end_bkt].len=",targets[end_bucket].length);

        }

        tmlast = pmarker.time;

    }

    INFO.knn_last_marker = INFO.knn_player_markers.length - 1;

}


// Look for gestures defined in INFO.knn_markers
//     - markers are "turn sigs" so no doubles, need to add "hold time" into token
//     - need to detect minimal "hold" period for a gesture to be valid (not in passing)
//
export function detectStaticMarker(pmarkers0) {
	var hidx = HISTORY.length - 1;
    var outs = [];
    if (pmarkers0.length === 0) return;

    for (var i in pmarkers0) {
        var marker = pmarkers0[i];
        var tokn0 = marker.tokn0;
        var time = marker.time;
        var scor = marker.scor;
        var same = marker.same;     // how long held at this end angle

        //kconsole_log5("static.924:         . . . DETECT STATIC   marks=",pmarkers0);   
        console.log("static.920:         . . . DETECT STATIC   hidx=",hidx,"   ",i,":  tokn0=",tokn0, " scor=",scor, " same=",same);
        if (tokn0 && (scor > 90) && (same > CONSTS.LIMB_MAX_SAME_POSE)) {

            for (var s in INFO.knn_static_tokens) {
                var gesture = INFO.knn_static_tokens[s];
                for (var g in gesture) {
                    var token = gesture[g];
                    if (token === tokn0) {
                        var obj = {};
                        obj.cmd = s;
                        obj.time = time;
                        obj.scor = scor;
                        obj.same = same;
                        outs.push(obj);

                        var display_gesture = false;
                        if (display_gesture) {
                            var t0 = Date.now();
                            TIMES.timer_stop_display = t0 + 300;
                            INFO.notify_title = s;
                            INFO.notify_color = "red";
                            //timerDisplayResult("Gesture.Detected");
                        }

                        kconsole_log5("static.976:    * * * * *  RAW TOKEN ",s,"  DETECTED  hidx=",hidx, " dist=",marker.dist," marker=",marker, " scor=",scor, " same=", same, " time=",(Date.now() %100000 /1000));
                    }
                }
            }
        }
    }
    //if (outs.length > 0) kconsole_log5("static.953:    # # # # # # # # #   DETECTED GESTURES=",outs);
    return outs;
}






const KNN_FIELDS = ["amx1", "amx2", "adl1", "adl2", "tdel"];
const KNN_WEIGHTS = [3.0, 3.0, 1.5, 1.5, 0.8];      // bigger wt has more impact (if wrong)


// return distance between two markers
//     - first has to be the same member
//     - may apply weights to diff params (more important have bigger mult)
//
export function knnDistance(marker1, marker2) {
    if (!marker1 || !marker2) return 88888;
    if (marker1["memb"] !== marker2["memb"]) return 99999;
    if (marker1["limb"] !== marker2["limb"]) return 99999;

    function calcDelta(field, marker1, marker2) {
        var src = marker1[field];
        var dst = marker2[field];
        var d2 = (src - dst) * (src - dst);
        //console.log("knn.2179:              _ _ _ ",field, " src=",src, " dst=",dst, "     sum=",sum);
        return d2;
    }

    var sum = 0;
    for (var i in KNN_FIELDS) {
        var field = KNN_FIELDS[i];
        var d2 = calcDelta(field, marker1, marker2);
        sum = sum + (d2 * KNN_WEIGHTS[i]);
    }
    return Math.sqrt(sum);
}



// find the closest match against the reference set
//
// TODO: Need to weigh the max angles more than deltas
//
const MARK_THRESHOLD = 90; //70, 80

export function knnBestMatch(marker) {
    var refs = INFO.knn_markers;
    var best = 999999, besti = null, omarker = null;
    var tokn0 = null
    var hidx = marker.time;
    for (var i in refs) {
        var rmarker = refs[i];

        var dist = knnDistance(marker, rmarker);
        if (dist < 99999) kconsole_log2("knn.955:                     . . KNN DIST ",i,"  mk=",marker.tokn,"   ref=", rmarker.tokn, "   dist=",parseInt(dist));
        if (dist < best) {
            best = dist;
            besti = i;
        }
    }

    if(best > MARK_THRESHOLD) {
        omarker = null;     // did not find close enough match;
        kconsole_log2("knn.961:             . . .",hidx,":  KNN MARKER  ..NO MATCH.. src=", marker.tokn, "  dist=",parseInt(best), " refs=",refs);
    } else {
        omarker = refs[besti];
        tokn0 = refs[besti].tokn;
        kconsole_log2("knn.970:     + + + + + + +",hidx,":  KNN MARKER  src=", marker.tokn, "   tokn0=",tokn0, "  dist=",parseInt(best));
    }

    return [ omarker, best ];
}



// convert INFO.knn_drill_tokens to INFO.knn_markers
//     - tokens are in groups that specify sequences (same group happens at same time)
//     - for knn we flatten it out for easy checking
//
export function knnLoadMarkers(motion_tokens, static_tokens) {
    var dmarkers = [];        // flattened drill sequence
    var dict = [];   // hold deduped token dictionary
    var tokens = []
    if (motion_tokens.length > 0) { tokens = motion_tokens.slice(); };

    for (var s in static_tokens) {
        var stoken = static_tokens[s];
        tokens = tokens.concat(stoken);
        kconsole_log("knn.1002:        . . . s= ",s, " stoken=", stoken);
    }
    //console.log("knn.1004:    # # # # #    tokens= ",tokens, " motion_tokens=", motion_tokens, "  static_tokens=",static_tokens);

    for (var i in tokens) {
        // flatten the arrays
        //
        var tokens1 = tokens[i];
        if (tokens1[0] && (tokens1[0].length > 1)) {
            for (var j in tokens1) {
                var token = tokens1[j];
                if (token.length > 0) {
                    var marker = getMotionMarker(token)
                    dmarkers = dmarkers.concat(marker);

                    var filter = dict.filter(m => {return (m == token)})
                    if (filter.length === 0) dict = dict.concat(token);
                    //console.log("knn.1015:          . . . ",i,":  ",token, " filter=", filter, "  dict=",dict);
                }
            }
        } else {
            var token = tokens1;
            if (token.length > 0) {
                var marker = getMotionMarker(token)
                dmarkers = dmarkers.concat(marker);

                var filter = dict.filter(m => {return (m == token)})
                if (filter.length === 0) dict = dict.concat(token);
            }
        }
    }

    INFO.knn_markers = dmarkers.slice();       // shallow array copy
    INFO.knn_token_dictionary = dict.slice();       // shallow array copy

    kconsole_log("knn.2217:   # # # # # # # #  KNN MARKER LOADED  ", tokens, " knn_markers=", INFO.knn_markers, "  dict=", INFO.knn_token_dictionary);
}



// one time processing for training
//     - extracts token dictionary
//
export function processKnnData(markers) {

    knnCluster(markers);        // gen INFO.knn_token_dictionary[] from player markers
    knnLoadMarkers(INFO.knn_token_dictionary);  // load them in dictionary

    INFO.knn_last_marker = 0;   // reset from the top
    for (var i = 0; i < markers.length; i++) {
        var marker = markers[i];

        var [ token, dist ] = knnBestMatch(marker);        // re-match against dictionary
        INFO.knn_player_markers[i].tokn0 = (token) ? token.tokn : null;   // null means no match
        INFO.knn_player_markers[i].dist = dist;     // distance from the target (closeness of match)
    }

    knnAnalyzeLoopPattern(INFO.knn_player_markers);  // collect statistics to find loops

    // re-analyze the player markers with revised tokens
    //
    INFO.knn_last_marker = 0;   // reset from the top
    for (var i = 0; i < markers.length; i++) {
        var marker = markers[i];
        analyzeMotionMarkers(marker);       // anan
    }
    console.log("process_knn.1222:    # # # # # # ONE_TIME PROCESS KNN DATA    knn_markers=",INFO.knn_markers);
}




// UTIL: setup knn for motion detection
//     - call from anywhere to init the state
//     - Note: Static gesture need to avoid "normal position", like arm is down
//
// ref: handleDevActionProcess()
//
//     - FORMAT:  <limb> <member> <max_deg1> <max_deg2> <del_deg1> <del_deg2> <time_del>
//                  - deg1: 1 = 20deg, 6 = 120deg  (0 to 120, 20deg)
//                  - deg2: 0 = -90deg, 6 = +90deg  (-90 to 90, 30deg)
//                  - time: log10
//
export function initKnnState() {

    
    //INFO.knn_drill_tokens = [['CF00220', 'CE00221'], ['DH00221', 'DG01221']];       // s2sr working
    //INFO.knn_static_tokens = {"RRAISE": ['AB11121', 'AA11011', 'AA32430'], 
                                //"LRAISE": ['BD01011', 'BC13331', 'BC00331', 'BC01011']}; // LEFT ARM RAISE
        //{"RRAISE": ['AA11231', 'AA32430', 'AB43342', 'AA11011'], 
                                    //'BD02221', 'BD13331', 'BC01011', 'BD24242'
    INFO.knn_static_tokens = {"RRAISE": [ 'AA23442', 'AA33431', 'AA43331', 'AA43442', 'AA33421',  // left - L shape
                                          'AB23442', 'AB33231', 'AB43231', 'AB43442', 'AB33421',  // right - L shape
                                          'AA43442', 'AA43312', 'AA41531',     // straight up
                                          'AB43442', 'AB43312', 'AB41531',     // straight up
                                         ],  // RIGHT ARM RAISE
                              "LRAISE": [ 'BC23442', 'BC33431', 'BC43331', 'BC43442', 'BC33421',   // left - L shape
                                          'BD23442', 'BD33231', 'BD43231', 'BD43442', 'BD33421',   // right - L shape

                                          'BC43442', 'BC43312', 'BC41531',       // left straight up
                                          'BD43442', 'BD43312', 'BD41531',       // right straight up
                                        ]}; // LEFT ARM RAISE

    if ((INFO.knn_drill_tokens.length > 0) || (Object.keys(INFO.knn_static_tokens).length > 0)) {
        // normal run mode
        //
        knnLoadMarkers(INFO.knn_drill_tokens, INFO.knn_static_tokens);        // TODO: This should come from db
        setValidLimbs(INFO.knn_token_dictionary);
    }

    INFO.knn_player_markers = [];
    INFO.knn_last_marker = 0;
    console.log("init_knn.1219:    # # # # # # KNN STATE INITIALIZED  knn_markers=",INFO.knn_markers);
}